import React from 'react';
import { profileAvatar } from "../component/ImageList";

export default function CustomAppStore() {
    return (
        <div className="content-right custom-app-store-page">
            {/* Search and Filter Section */}
            <div className="search-filter-section">
                <div className="search-bar">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        className="search-icon"
                    >
                        <path
                            d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                            stroke="#E1730B"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M17.5 17.5L13.875 13.875"
                            stroke="#E1730B"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <input
                        type="text"
                        placeholder="Search by name / company"
                        className="search-input"
                    />
                </div>
                <button className="filter-btn">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M16.4062 4.69678C14.5256 4.69678 12.9441 6.04475 12.5793 7.82178H2.34375C1.91228 7.82178 1.5625 8.17156 1.5625 8.60303C1.5625 9.0345 1.91228 9.38428 2.34375 9.38428H12.5793C12.9441 11.1613 14.5256 12.5093 16.4062 12.5093C18.2869 12.5093 19.8684 11.1613 20.2332 9.38428H22.6562C23.0877 9.38428 23.4375 9.0345 23.4375 8.60303C23.4375 8.17156 23.0877 7.82178 22.6562 7.82178H20.2332C19.8684 6.04475 18.2869 4.69678 16.4062 4.69678ZM16.4062 6.25928C17.7099 6.25928 18.75 7.29938 18.75 8.60303C18.75 9.90668 17.7099 10.9468 16.4062 10.9468C15.1026 10.9468 14.0625 9.90668 14.0625 8.60303C14.0625 7.29938 15.1026 6.25928 16.4062 6.25928Z"
                            fill="white"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8.59375 12.5093C6.71313 12.5093 5.1316 13.8573 4.76685 15.6343H2.34375C1.91228 15.6343 1.5625 15.9841 1.5625 16.4155C1.5625 16.847 1.91228 17.1968 2.34375 17.1968H4.76685C5.1316 18.9738 6.71313 20.3218 8.59375 20.3218C10.4744 20.3218 12.0559 18.9738 12.4207 17.1968H22.6562C23.0877 17.1968 23.4375 16.847 23.4375 16.4155C23.4375 15.9841 23.0877 15.6343 22.6562 15.6343H12.4207C12.0559 13.8573 10.4744 12.5093 8.59375 12.5093ZM8.59375 14.0718C9.8974 14.0718 10.9375 15.1119 10.9375 16.4155C10.9375 17.7192 9.8974 18.7593 8.59375 18.7593C7.2901 18.7593 6.25 17.7192 6.25 16.4155C6.25 15.1119 7.2901 14.0718 8.59375 14.0718Z"
                            fill="white"
                        />
                    </svg>
                </button>
            </div>

            <div className="connection-request-section mb-4">
                <div className='connection-request-section-header flex justify-between items-center'>
                    <h2 className='font-bold'>Request Sent</h2>
                    <span className='view-all-btn cursor-pointer'>View All</span>
                </div>
                <div className='connection-request-list'>
                    <div className='connection-request-item flex items-center flex-wrap gap-4'>
                        <div className='connection-request-item-info flex flex-column justify-between'>
                            <div className='connection-request-item-info-image mb-3'>
                                <img src={profileAvatar} alt="Biswajit Das" />
                            </div>
                            <div className='connection-request-item-info-name'>
                                <h3 className='text-white'>Biswajit Das</h3>
                            </div>
                        </div>
                        <div className='connection-request-item-info flex flex-column justify-between'>
                            <div className='connection-request-item-info-image mb-3'>
                                <img src={profileAvatar} alt="Biswajit Das" />
                            </div>
                            <div className='connection-request-item-info-name'>
                                <h3 className='text-white'>Biswajit Das</h3>
                            </div>
                        </div>
                        <div className='connection-request-item-info flex flex-column justify-between'>
                            <div className='connection-request-item-info-image mb-3'>
                                <img src={profileAvatar} alt="Biswajit Das" />
                            </div>
                            <div className='connection-request-item-info-name'>
                                <h3 className='text-white'>Biswajit Das</h3>
                            </div>
                        </div>
                        <div className='connection-request-item-info flex flex-column justify-between'>
                            <div className='connection-request-item-info-image mb-3'>
                                <img src={profileAvatar} alt="Biswajit Das" />
                            </div>
                            <div className='connection-request-item-info-name'>
                                <h3 className='text-white'>Biswajit Das</h3>
                            </div>
                        </div>
                        <div className='connection-request-item-info flex flex-column justify-between'>
                            <div className='connection-request-item-info-image mb-4'>
                                <img src={profileAvatar} alt="Biswajit Das" />
                            </div>
                            <div className='connection-request-item-info-name'>
                                <h3 className='text-white'>Biswajit Das</h3>
                            </div>
                        </div>
                        <div className='connection-request-item-info flex flex-column justify-between'>
                            <div className='connection-request-item-info-image mb-4'>
                                <img src={profileAvatar} alt="Biswajit Das" />
                            </div>
                            <div className='connection-request-item-info-name'>
                                <h3 className='text-white'>Biswajit Das</h3>
                            </div>
                        </div>
                        <div className='connection-request-item-info flex flex-column justify-between'>
                            <div className='connection-request-item-info-image mb-3'>
                                <img src={profileAvatar} alt="Biswajit Das" />
                            </div>
                            <div className='connection-request-item-info-name'>
                                <h3 className='text-white'>Biswajit Das</h3>
                            </div>
                        </div>
                        <div className='connection-request-item-info flex flex-column justify-between'>
                            <div className='connection-request-item-info-image mb-3'>
                                <img src={profileAvatar} alt="Biswajit Das" />
                            </div>
                            <div className='connection-request-item-info-name'>
                                <h3 className='text-white'>Biswajit Das</h3>
                            </div>
                        </div>


                    </div>
                </div>
            </div>

            <div className='member-card-header'>
                <h2 className='font-bold text-[#E1730B] mb-3'>Request Received</h2>
            </div>

            {/* Member Cards Grid */}
            <div className="member-cards-grid">
                {/* Card 1 */}
                <div className="member-card">
                    <div className="member-card-content">
                        <div className="member-info">
                            <p className="member-since">Member since 13 Feb 2024</p>
                            <h3 className="member-name">Biswajit Das</h3>
                            <p className="member-role">Developer</p>
                            <p className="member-location">Altglienickle- Germany</p>
                        </div>
                        <div className="member-image">
                            <img src={profileAvatar} alt="Biswajit Das" />
                        </div>
                    </div>
                    <div className="member-card-actions">
                        <button className="accept-btn">Accept</button>
                        <button className="decline-btn">Decline</button>
                    </div>
                </div>

                {/* Card 2 */}
                <div className="member-card">
                    <div className="member-card-content">
                        <div className="member-info">
                            <p className="member-since">Member since 13 Feb 2024</p>
                            <h3 className="member-name">Biswajit Das</h3>
                            <p className="member-role">Developer</p>
                            <p className="member-location">Altglienickle- Germany</p>
                        </div>
                        <div className="member-image">
                            <img src={profileAvatar} alt="Biswajit Das" />
                        </div>
                    </div>
                    <div className="member-card-actions">
                        <button className="accept-btn">Accept</button>
                        <button className="decline-btn">Decline</button>
                    </div>
                </div>

                {/* Card 3 */}
                <div className="member-card">
                    <div className="member-card-content">
                        <div className="member-info">
                            <p className="member-since">Member since 13 Feb 2024</p>
                            <h3 className="member-name">Biswajit Das</h3>
                            <p className="member-role">Developer</p>
                            <p className="member-location">Altglienickle- Germany</p>
                        </div>
                        <div className="member-image">
                            <img src={profileAvatar} alt="Biswajit Das" />
                        </div>
                    </div>
                    <div className="member-card-actions">
                        <button className="accept-btn">Accept</button>
                        <button className="decline-btn">Decline</button>
                    </div>
                </div>

                {/* Card 4 */}
                <div className="member-card">
                    <div className="member-card-content">
                        <div className="member-info">
                            <p className="member-since">Member since 13 Feb 2024</p>
                            <h3 className="member-name">Biswajit Das</h3>
                            <p className="member-role">Developer</p>
                            <p className="member-location">Altglienickle- Germany</p>
                        </div>
                        <div className="member-image">
                            <img src={profileAvatar} alt="Biswajit Das" />
                        </div>
                    </div>
                    <div className="member-card-actions">
                        <button className="accept-btn">Accept</button>
                        <button className="decline-btn">Decline</button>
                    </div>
                </div>

                {/* Card 5 */}
                <div className="member-card">
                    <div className="member-card-content">
                        <div className="member-info">
                            <p className="member-since">Member since 13 Feb 2024</p>
                            <h3 className="member-name">Biswajit Das</h3>
                            <p className="member-role">Developer</p>
                            <p className="member-location">Altglienickle- Germany</p>
                        </div>
                        <div className="member-image">
                            <img src={profileAvatar} alt="Biswajit Das" />
                        </div>
                    </div>
                    <div className="member-card-actions">
                        <button className="accept-btn">Accept</button>
                        <button className="decline-btn">Decline</button>
                    </div>
                </div>

                {/* Card 6 */}
                <div className="member-card">
                    <div className="member-card-content">
                        <div className="member-info">
                            <p className="member-since">Member since 13 Feb 2024</p>
                            <h3 className="member-name">Biswajit Das</h3>
                            <p className="member-role">Developer</p>
                            <p className="member-location">Altglienickle- Germany</p>
                        </div>
                        <div className="member-image">
                            <img src={profileAvatar} alt="Biswajit Das" />
                        </div>
                    </div>
                    <div className="member-card-actions">
                        <button className="accept-btn">Accept</button>
                        <button className="decline-btn">Decline</button>
                    </div>
                </div>

                <div className="member-card">
                    <div className="member-card-content">
                        <div className="member-info">
                            <p className="member-since">Member since 13 Feb 2024</p>
                            <h3 className="member-name">Biswajit Das</h3>
                            <p className="member-role">Developer</p>
                            <p className="member-location">Altglienickle- Germany</p>
                        </div>
                        <div className="member-image">
                            <img src={profileAvatar} alt="Biswajit Das" />
                        </div>
                    </div>
                    <div className="member-card-actions">
                        <button className="accept-btn">Accept</button>
                        <button className="decline-btn">Decline</button>
                    </div>
                </div>
                <div className="member-card">
                    <div className="member-card-content">
                        <div className="member-info">
                            <p className="member-since">Member since 13 Feb 2024</p>
                            <h3 className="member-name">Biswajit Das</h3>
                            <p className="member-role">Developer</p>
                            <p className="member-location">Altglienickle- Germany</p>
                        </div>
                        <div className="member-image">
                            <img src={profileAvatar} alt="Biswajit Das" />
                        </div>
                    </div>
                    <div className="member-card-actions">
                        <button className="accept-btn">Accept</button>
                        <button className="decline-btn">Decline</button>
                    </div>
                </div>
                <div className="member-card">
                    <div className="member-card-content">
                        <div className="member-info">
                            <p className="member-since">Member since 13 Feb 2024</p>
                            <h3 className="member-name">Biswajit Das</h3>
                            <p className="member-role">Developer</p>
                            <p className="member-location">Altglienickle- Germany</p>
                        </div>
                        <div className="member-image">
                            <img src={profileAvatar} alt="Biswajit Das" />
                        </div>
                    </div>
                    <div className="member-card-actions">
                        <button className="accept-btn">Accept</button>
                        <button className="decline-btn">Decline</button>
                    </div>
                </div>
                <div className="member-card">
                    <div className="member-card-content">
                        <div className="member-info">
                            <p className="member-since">Member since 13 Feb 2024</p>
                            <h3 className="member-name">Biswajit Das</h3>
                            <p className="member-role">Developer</p>
                            <p className="member-location">Altglienickle- Germany</p>
                        </div>
                        <div className="member-image">
                            <img src={profileAvatar} alt="Biswajit Das" />
                        </div>
                    </div>
                    <div className="member-card-actions">
                        <button className="accept-btn">Accept</button>
                        <button className="decline-btn">Decline</button>
                    </div>
                </div>
                <div className="member-card">
                    <div className="member-card-content">
                        <div className="member-info">
                            <p className="member-since">Member since 13 Feb 2024</p>
                            <h3 className="member-name">Biswajit Das</h3>
                            <p className="member-role">Developer</p>
                            <p className="member-location">Altglienickle- Germany</p>
                        </div>
                        <div className="member-image">
                            <img src={profileAvatar} alt="Biswajit Das" />
                        </div>
                    </div>
                    <div className="member-card-actions">
                        <button className="accept-btn">Accept</button>
                        <button className="decline-btn">Decline</button>
                    </div>
                </div>
            </div>
        </div>
    );
}